import React from 'react';
import './Education.css';
const Education = () => (
  <section className="education">
    <h2>Education</h2>
    <ul>
      <li>
        <strong>B.Tech in Computer Science (AI & ML), 2027</strong>
        <br />Supreme Knowledge Foundation Group of Institutions (MAKAUT, WB), Hooghly
        <br />GPA: 7.45 (Till 5th Semester)
      </li>
      <li>
        <strong>Higher Secondary Education,PCM & CS, 2023</strong>
        <br />Uttarpara Amarendra Vidyapith (WBCHSE Board)
        <br />Percentage: 61.6%
      </li>
      <li>
        <strong>Secondary Education, 2021</strong>
        <br />Uttarpara Amarendra Vidyapith (WBBSE Board)
        <br />Percentage: 79.71%
      </li>
    </ul>
  </section>
);

export default Education;
